module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10190.2b9720dc.jpg";